/**
 * Created by linjianxi on 2017/6/8.
 */
export const getUserCashMonth = (state) => {
  return state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/hqpord_detail/getter.js